import { graphql } from '@/gql';
import type { MailingInputType } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createMailing = async (data: MailingInputType): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateMailing($data: MailingInputType!) {
        createMailing(data: $data) {
          id
        }
      }
    `),
    variables: {
      data,
    },
  });

  return !!response.data?.createMailing;
};
